export default {
	path: '/setting-push-alarm',
	redirect: '/setting-push-alarm',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'settingPushAlarmHome',
			component: () => import('@/views/mng/SettingPushAlarm'),
		},
	],
};
